import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { getResponsibleGamblingPage } from '../../../modules/content/selectors';
import contentBackup from '../../../../resources/responsibleGamblingBackup.json';

export const ResponsibleGambling = ({ contentStackContent }) => {
  let content;
  if (contentStackContent) {
    content = contentStackContent;
  } else {
    content = contentBackup;
  }
  return (
    <div className="responsible-gambling">
      <div className="container--fixed">
        <h2 className="responsible-gambling__header" dangerouslySetInnerHTML={{ __html: content.title }} />
        <div className="cms-content" dangerouslySetInnerHTML={{ __html: content.text }} />
      </div>
    </div>
  );
};

ResponsibleGambling.propTypes = {
  contentStackContent: PropTypes.object
};

const mapStateToProps = (state) => ({
  contentStackContent: getResponsibleGamblingPage(state)
});

export default connect(mapStateToProps)(ResponsibleGambling);
